export default __webpack_public_path__ + "static/media/testimonial2.79e3b1d9.png";